import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/doujin';

const navItems = [
  { to: '/', label: '今日更新' },
  { to: '/updates', label: '全部更新' },
  { to: '/faq', label: '追更指南' },
  { to: '/about', label: '关于我们' },
  { to: '/contact', label: '联系我们' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setCatOpen(false);
  }, [location.pathname]);

  return (
    <header className="w-full">
      <div className="hidden md:block bg-primary-700 text-background-50 text-xs">
        <div className="px-4 md:px-6 max-w-7xl mx-auto h-9 flex items-center justify-between">
          <p className="flex items-center gap-2">
            <i className="ri-calendar-check-line text-accent-400"></i>
            每日整理 · 今日同人库今日更新一手掌握，追更不再错过
          </p>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1"><i className="ri-english-input"></i>简体中文</span>
            <a href="#updates" className="hover:text-accent-300 transition-colors flex items-center gap-1">
              <i className="ri-arrow-right-up-line"></i>浏览今日更新
            </a>
          </div>
        </div>
      </div>

      <div className={`transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur shadow-sm' : 'bg-transparent'}`}>
        <div className="px-4 md:px-6 max-w-7xl mx-auto h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
              <i className="ri-book-open-line"></i>
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950">
              今日同人库<span className="text-primary-600">.</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.slice(0, 2).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-100 text-primary-800' : 'text-foreground-600 hover:text-primary-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="relative" onMouseEnter={() => setCatOpen(true)} onMouseLeave={() => setCatOpen(false)}>
              <button
                type="button"
                className="px-4 py-2 rounded-md text-sm font-medium text-foreground-600 hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                分类浏览 <i className={`ri-arrow-down-s-line transition-transform ${catOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {catOpen && (
                <div className="absolute left-0 top-full pt-2 z-40 w-64">
                  <div className="bg-background-50 border border-background-200 rounded-lg p-2 grid grid-cols-2 gap-1">
                    {categories.map((c) => (
                      <Link
                        key={c.slug}
                        to={`/category/${c.slug}`}
                        className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900 transition-colors whitespace-nowrap"
                      >
                        <i className={`${c.icon} text-secondary-600`}></i>
                        {c.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {navItems.slice(2).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-100 text-primary-800' : 'text-foreground-600 hover:text-primary-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/updates"
              className="px-4 py-2 rounded-md border border-primary-200 text-primary-700 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              追更清单
            </Link>
            <a
              href="#subscribe"
              className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              订阅更新
            </a>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>

        {menuOpen && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  className={({ isActive }) =>
                    `px-4 py-2.5 rounded-md text-sm font-medium ${
                      isActive ? 'bg-primary-100 text-primary-800' : 'text-foreground-700'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <p className="px-4 pt-3 text-xs text-foreground-500 font-medium">分类浏览</p>
              <div className="grid grid-cols-2 gap-1 px-2">
                {categories.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-600 hover:bg-secondary-100 transition-colors"
                  >
                    <i className={`${c.icon} text-secondary-600`}></i>
                    {c.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}